import * as React from "react";
const SvgFiRrTentArrowsDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tent-arrows-down_svg__a)">
      <path
        fill="#062147"
        d="M2.907 8.133.322 5.732a1 1 0 1 1 1.361-1.465L4 6.419V1a1 1 0 0 1 2 0v5.421l2.317-2.153a1 1 0 1 1 1.361 1.465l-2.61 2.426a2.9 2.9 0 0 1-2.059.844 2.97 2.97 0 0 1-2.103-.869zM23.73 4.32a1 1 0 0 0-1.413-.052l-2.317 2.153V1a1 1 0 0 0-2 0v5.42l-2.317-2.152a1 1 0 1 0-1.362 1.465l2.585 2.4c.58.581 1.345.869 2.104.869.75 0 1.497-.282 2.058-.843l2.61-2.426a1 1 0 0 0 .052-1.413m-2.127 13.616a4.24 4.24 0 0 1-.271 4.09 4.26 4.26 0 0 1-3.604 1.975H6.278a4.25 4.25 0 0 1-3.603-1.975 4.24 4.24 0 0 1-.27-4.09c.021-.048 5.846-8.668 5.872-8.698 1.203-1.392 2.055-2.237 3.725-2.237 1.435 0 2.672.756 3.781 2.31 0 0 5.795 8.578 5.819 8.625M14.477 22l-1.973-3.644c-.154-.327-.402-.356-.502-.356s-.348.029-.474.302l-2 3.698zm5.34-3.154-5.677-8.395C13.224 9.167 12.515 9 12 9c-.691 0-1.024.178-2.173 1.5l-5.64 8.345a2.22 2.22 0 0 0 .174 2.104 2.24 2.24 0 0 0 1.917 1.05h.974l2.49-4.597c.39-.845 1.267-1.403 2.26-1.403a2.5 2.5 0 0 1 2.287 1.458l2.464 4.542h.974c.793 0 1.491-.383 1.918-1.05a2.22 2.22 0 0 0 .174-2.104z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tent-arrows-down_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTentArrowsDown;
